module.exports = __webpack_public_path__ + "static/media/song.e553b0fd.less";